import React from "react";

const TshirtField = ({
  name,
  label,
  value = "",
  onChange,
  required = false
}) => {
  const sizes = ["XS", "S", "M", "L", "XL", "XXL"];
  const selectId = `${name}-select`;

  return (
    <div>
      <label htmlFor={selectId}>
        {label}
        {required && " *"}
      </label>
      <select
        id={selectId}
        className="field"
        name={name}
        value={value || ""}
        onChange={onChange}
        required={required}
        aria-label="Select your T-shirt size"
      >
        <option value="" disabled>
          Select a size
        </option>
        {sizes.map((size) => (
          <option key={size} value={size}>
            {size}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TshirtField;
